<template>
  <!--底部-->
  <div class="myFooter">
    <!--内容-->
    <div class="m">
      <div class="myFooter_main">
        <!--左边-->
        <div class="myFooter_main_l">
          <dl>
            <dt>关于</dt>
            <dd v-if="webConfig">
              <router-link to="/about_us" v-if="webConfig.aboutUs">关于我们</router-link>
              <router-link :to="`/about_us_park_detail?parkId=${webConfig.parkId}`" v-else-if="webConfig.parkId">关于我们</router-link>
            </dd>
            <dd>
              <router-link to="/personal_center/park_user/park_notice/notice_list">最新通告</router-link>
            </dd>
          </dl>
          <dl>
            <dt>全部空间</dt>
            <dd>
              <router-link to="/office_space?type=MeetingTypeOffice">办公室</router-link>
            </dd>
            <dd>
              <router-link to="/office_space?type=MeetingTypeStation">开放工位</router-link>
            </dd>
            <dd>
              <router-link to="/office_space?type=MeetingTypeMeeting">会议室预订</router-link>
            </dd>
          </dl>
          <dl>
            <dt>平台服务</dt>
            <dd>
              <router-link to="/user_protocol">用户协议</router-link>
            </dd>
            <dd>
              <router-link to="/privacy_clauset">隐私声明</router-link>
            </dd>
          </dl>
          <dl v-if="webConfig">
            <dt>联系我们</dt>
            <dd>{{webConfig.tel || ''}}</dd>
            <dd>{{webConfig.contactAddress || ''}}</dd>
          </dl>
        </div>
        <!--右边-->
        <div class="myFooter_main_r" v-if="webConfig">
          <div class="service_img">
            <img title="二维码" :src="webConfig.customerServiceQrCodeFull || ''" alt />
            <p>客服小助手</p>
          </div>
        </div>
      </div>
    </div>
    <!--水平线-->
    <!-- <div class="footer_hr"></div> -->
    <!--版权-->
    <div class="m" v-if="webConfig">
      <div class="myFooter_copyright">
        <div>
          <h3>版权所有：{{webConfig.copyright || ''}}</h3>
        </div>
        <div style="padding-left:15px;color:#9a9a9a">
          <a href="http://beian.miit.gov.cn" target="_blank">{{webConfig.icp || ''}}</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  computed: {
    webConfig() {
      return this.$store.state.webConfig;
    }
  }
};
</script>

<style lang="scss">
.myFooter {
  background-color: #fff;
  border-top: 1px solid #eee;
  /*内容*/
  .myFooter_main {
    border-bottom: 1px solid #eee;
    display: flex;
    justify-content: space-between;
    /*左边*/
    .myFooter_main_l {
      padding-top: 12px;
      padding-bottom: 20px;
      display: flex;
      dl {
        font-size: 14px;
        margin-right: 80px;
        dt {
          color: #343434;
          line-height: 46px;
          a {
            color: #fff;
            line-height: 46px;
          }
        }
        dd {
          color: #9a9a9a;
          line-height: 30px;
          a {
            color: #9a9a9a;
            line-height: 30px;
          }
        }
      }
    }
    /*右边*/
    .myFooter_main_r {
      padding-top: 30px;
      /*二维码*/
      .service_img {
        img {
          display: inline-block;
          width: 85px;
          height: 85px;
          background-color: #cbcede;
        }
        p {
          text-align: center;
          font-size: 14px;
          line-height: 34px;
          color: #9a9a9a;
        }
      }
    }
  }
  /*水平线*/
  .footer_hr {
    border-bottom: 1px solid #45494b;
  }
  /*版权*/
  .myFooter_copyright {
    line-height: 52px;

    color: #9a9a9a;
    display: flex;
    h3 {
      color: #9a9a9a;
      font-size: 14px;
    }
    a {
      font-size: 14px;
      color: #9a9a9a;
    }
  }
}
</style>
